import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconBookOpened = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.74984 2.91667C2.39734 2.7125 3.109 2.625 3.7915 2.625C4.929 2.625 6.154 2.85833 6.99984 3.5C7.84567 2.85833 9.07067 2.625 10.2082 2.625C11.3457 2.625 12.5707 2.85833 13.4165 3.5V12.0458C13.4165 12.1917 13.2707 12.3375 13.1248 12.3375C13.0665 12.3375 13.0373 12.3083 12.979 12.3083C12.1915 11.9292 11.054 11.6667 10.2082 11.6667C9.07067 11.6667 7.84567 11.9 6.99984 12.5417C6.21234 12.0458 4.78317 11.6667 3.7915 11.6667C2.829 11.6667 1.83734 11.8417 1.02067 12.2792C0.962337 12.3083 0.933169 12.3083 0.874836 12.3083C0.729003 12.3083 0.58317 12.1625 0.58317 12.0167V3.5C0.933169 3.2375 1.31234 3.0625 1.74984 2.91667ZM1.74984 10.7917C2.3915 10.5875 3.0915 10.5 3.7915 10.5C4.78317 10.5 6.21234 10.8792 6.99984 11.375V4.66667C6.21234 4.17083 4.78317 3.79167 3.7915 3.79167C3.0915 3.79167 2.3915 3.87917 1.74984 4.08333V10.7917Z",
		fill: "white"
	})
});
export default SvgIconBookOpened;
